import { DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, CommonFlags as c } from "@mcurros2/microm";

const columns = () =>
(
    {
        c_personal_id: new EntityColumn<string>({ name: 'c_personal_id', type: 'char', length: 20, flags: c.PK, prompt: 'Personal Id' }),
        vc_url_dashboard: new EntityColumn<string>({ name: 'vc_url_dashboard', type: 'varchar', length: 2048, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Url Dashboard' }),
        vc_workspace_id: new EntityColumn<string>({ name: 'vc_workspace_id', type: 'varchar', length: 2048, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Workspace Id' }),
        vc_report_id: new EntityColumn<string>({ name: 'vc_report_id', type: 'varchar', length: 2048, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Report Id' }),
        vc_token: new EntityColumn<string>({ name: 'vc_token', type: 'varchar', length: 2048, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Token' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
    }
)

export class DashboardSupervisoresDef extends EntityDefinition {

    columns = columns();
    views = views();

    constructor() {
        super('DashboardSupervisores');
    }
}